module.exports = __webpack_public_path__ + "img/dotes_12x18.427b41e2.svg";